// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Montserrat/static/Montserrat-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Montserrat/static/Montserrat-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/Montserrat/static/Montserrat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'MontserratThin';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'MontserratBlack';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'MontserratRegular';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}
body{
    font-family: "MontserratRegular" !important;
}
.dashboard {
    min-height: 100vh;
    background-color: #f5f5f5;
    padding: 20px;
}

.dashboard-header {
    margin-bottom: 30px;
}

.dashboard-header h1 {
    font-size: 2.5rem;
    color: #333;
    margin: 0;
    font-weight: 600;
}

.dashboard-content {
    display: flex;
    flex-direction: column;
    gap: 30px;
}

@media (max-width: 768px) {
    .dashboard {
        padding: 15px;
    }

    .dashboard-header h1 {
        font-size: 2rem;
    }

    .dashboard-content {
        gap: 20px;
    }
}

.settings-link {
    margin-left: auto;
    font-size: 18px;
    font-weight: bold!important;
    padding: 8px 16px;
    background-color: #f3f4f6;
    color: #111827;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    text-decoration: none;
    transition: background-color 0.2s ease;
}

.settings-link:hover {
    background-color: #e5e7eb;
}
.action-link {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    padding: 8px 16px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    text-decoration: none;
    background-color: #f3f4f6;
    color: #111827;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.action-link:hover {
    background-color: #e5e7eb;
}

.logout-variant {
    background-color: #fef2f2;
    border-color: #fca5a5;
    color: #991b1b;
}

.logout-variant:hover {
    background-color: #fee2e2;
}

`, "",{"version":3,"sources":["webpack://./src/css/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,+DAAoF;IACpF,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,8BAA8B;IAC9B,+DAAqF;IACrF,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,gCAAgC;IAChC,+DAAuF;IACvF,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["@font-face {\r\n    font-family: 'MontserratThin';\r\n    src: url('../assets/fonts/Montserrat/static/Montserrat-Thin.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n}\r\n@font-face {\r\n    font-family: 'MontserratBlack';\r\n    src: url('../assets/fonts/Montserrat/static/Montserrat-Black.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n}\r\n@font-face {\r\n    font-family: 'MontserratRegular';\r\n    src: url('../assets/fonts/Montserrat/static/Montserrat-Regular.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n}\r\nbody{\r\n    font-family: \"MontserratRegular\" !important;\r\n}\r\n.dashboard {\r\n    min-height: 100vh;\r\n    background-color: #f5f5f5;\r\n    padding: 20px;\r\n}\r\n\r\n.dashboard-header {\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.dashboard-header h1 {\r\n    font-size: 2.5rem;\r\n    color: #333;\r\n    margin: 0;\r\n    font-weight: 600;\r\n}\r\n\r\n.dashboard-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 30px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .dashboard {\r\n        padding: 15px;\r\n    }\r\n\r\n    .dashboard-header h1 {\r\n        font-size: 2rem;\r\n    }\r\n\r\n    .dashboard-content {\r\n        gap: 20px;\r\n    }\r\n}\r\n\r\n.settings-link {\r\n    margin-left: auto;\r\n    font-size: 18px;\r\n    font-weight: bold!important;\r\n    padding: 8px 16px;\r\n    background-color: #f3f4f6;\r\n    color: #111827;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 6px;\r\n    text-decoration: none;\r\n    transition: background-color 0.2s ease;\r\n}\r\n\r\n.settings-link:hover {\r\n    background-color: #e5e7eb;\r\n}\r\n.action-link {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    font-size: 14px;\r\n    padding: 8px 16px;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 6px;\r\n    text-decoration: none;\r\n    background-color: #f3f4f6;\r\n    color: #111827;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s ease;\r\n}\r\n\r\n.action-link:hover {\r\n    background-color: #e5e7eb;\r\n}\r\n\r\n.logout-variant {\r\n    background-color: #fef2f2;\r\n    border-color: #fca5a5;\r\n    color: #991b1b;\r\n}\r\n\r\n.logout-variant:hover {\r\n    background-color: #fee2e2;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
